import store from "@/store";
import messages from "../languages/index"
let lang = localStorage.getItem('language')
export default {
  install(Vue) {
    Vue.prototype.$copy = function (string) {
      navigator.clipboard.writeText(string);
      try {
        store.commit('setFeedbackSnack', {
          msg: messages[lang].copySuccessfully,
          color: 'success',
        })
      } catch (err) {
        console.warn("Oops, unable to copy");
      }
    }
  }
}